import { useState } from 'react'
import { useSelector } from 'react-redux'
import ClearCartModal from 'Checkout/Components/Cart/ClearCartModal'
import Header from 'Checkout/Components/Cart/Header'
import RemovedAlert from 'Checkout/Components/Shared/RemovedAlert'
import Reservations from 'Checkout/Components/Cart/Reservations'

const CartDetails = () => {
  const reservationRemoved = useSelector(state => state.cart.reservationRemoved)
  const [isClearCartModalOpen, setIsClearCartModalOpen] = useState(false)

  const toggleClearCartModal = () => setIsClearCartModalOpen(prevState => !prevState)

  return (
    <div className="cart-details">
      <Header toggleClearCartModal={toggleClearCartModal} />

      {reservationRemoved && <RemovedAlert />}

      <Reservations />

      <ClearCartModal isOpen={isClearCartModalOpen} toggle={toggleClearCartModal} />
    </div>
  )
}

export default CartDetails
